import { faPen } from '@fortawesome/pro-light-svg-icons';
import React, { useCallback } from 'react';
import { ButtonWithIcon } from '../ButtonWithIcon';
import { ReviewFieldValue } from './ReviewFieldValue';

export type FieldValue =
  | string
  | number
  | boolean
  | File
  | null
  | undefined
  | Array<any>;

export interface ReviewFieldItem {
  id: string;
  label: string;
  value: FieldValue;
}
interface ReviewItemProps {
  field: ReviewFieldItem;
  index: number;
  onEdit: () => void;
  isLast?: boolean;
}

export const ReviewItem: React.FC<ReviewItemProps> = ({
  field,
  index,
  onEdit,
  isLast = false,
}) => {
  const handleEdit = useCallback(() => {
    onEdit();
  }, [onEdit]);

  return (
    <div className='relative flex items-start'>
      {/* Connecting line - positioned absolutely */}
      {!isLast && (
        <div
          className='absolute left-[9px] top-[35px] w-[2px] h-[calc(100%-19px)] bg-light-blue-100'
          style={{ zIndex: 0 }}
        />
      )}

      {/* Index circle */}
      <div className='flex-shrink-0 mr-3 sm:mr-8 relative pt-4'>
        <div className='w-5 h-5 rounded-full border border-reskin-primary-blue flex items-center justify-center text-reskin-primary-blue text-xs font-inter-semibold bg-white'>
          {index}
        </div>
      </div>

      {/* Content area with border */}
      <div
        className={`flex items-end sm:items-start flex-1 py-3 ${
          !isLast ? 'border-b border-real-grey-200' : ''
        }`}
      >
        {/* Question */}
        <div className='flex-1 font-inter-medium hidden md:block'>
          <div className='text-reskin-primary-dark2 text-base leading-[22px]'>
            {field.label}
          </div>
        </div>

        {/* Answer */}
        <div className='flex-1 min-w-0 pr-8 font-inter-light hidden md:block'>
          <div className='text-reskin-primary-dark2 text-base leading-[22px]'>
            <ReviewFieldValue value={field.value} fieldId={field.id} />
          </div>
        </div>

        <div className='flex-1 min-w-0 pr-2 md:pr-8 md:hidden flex flex-col gap-2'>
          <div className='text-reskin-primary-dark2 text-base font-inter-medium leading-[22px]'>
            {field.label}
          </div>
          <div className='text-reskin-primary-dark2 text-base font-inter-light leading-[22px]'>
            <ReviewFieldValue value={field.value} fieldId={field.id} />
          </div>
        </div>

        {/* Edit button */}
        <ButtonWithIcon
          onClickHandler={handleEdit}
          iconElement={faPen}
          buttonText='Edit'
        />
      </div>
    </div>
  );
};
